import { IData, IResult } from '@/interfaces/common'
import request from '@/common/request'
import { AxiosPromise } from 'axios'

export const GetReport = (number : string) : AxiosPromise<IResult<IData>> =>
  request({
    url: `//api.wms.ttpvp.com/api/Report/${number}`,
    method: 'get'
  })
